import { loadStripe, type Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripeBrowser(): Promise<Stripe | null> {
  const pk = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
  if (!pk) return Promise.resolve(null);
  if (!stripePromise) {
    stripePromise = loadStripe(pk);
  }
  return stripePromise;
}

export function isStripePublishableConfigured(): boolean {
  return Boolean(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);
}
